import ReactTwitchEmbedVideo from "react-twitch-embed-video";

function App() {
  const height = window.screen.height - 170;
  const width = window.screen.width;

  return (
    <div className="flex flex-1 bg-black items-center justify-center">
      <ReactTwitchEmbedVideo
        channel="lojachucktcg"
        theme="dark"
        width={width}
        height={height}
        layout="video"
        allowfullscreen={false}
      />
    </div>
  );
}

export default App;
